var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BjDivider",
        {
          scopedSlots: _vm._u([
            {
              key: "right",
              fn: function () {
                return [
                  _vm.isStatus === "audit"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onEdit },
                        },
                        [_vm._v(_vm._s(_vm.$t("editText")))]
                      )
                    : _vm._e(),
                  _vm.isStatus === "audit" &&
                  _vm.auditStatusList.includes(_vm.data.status) &&
                  _vm.permissionBtns("WAIT_FIRST_AUDIT")
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.firstAudit },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("BusinessPurchaseApplyDetail.firstReview")
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.isStatus === "audit" &&
                  _vm.auditStatusList2.includes(_vm.data.status) &&
                  _vm.permissionBtns("WAIT_SECOND_AUDIT")
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.secondAudit },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("BusinessPurchaseApplyDetail.secondReview")
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.isStatus === "audit" &&
                  _vm.auditStatusList3.includes(_vm.data.status) &&
                  _vm.permissionBtns("WAIT_THIRD_AUDIT")
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.thirdAudit },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("BusinessPurchaseApplyDetail.thirdReview")
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.showLog } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("BusinessPurchaseApplyDetail.operationLog")
                        )
                      ),
                    ]
                  ),
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v(_vm._s(_vm.$t("backText"))),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(
            " " + _vm._s(_vm.$t("BusinessPurchaseApplyDetail.status")) + " "
          ),
        ]
      ),
      _c("div", { staticClass: "bj-row mt20" }, [
        _c("div", { staticClass: "bj-col bj-col-24" }, [
          _c("div", { staticClass: "bj-form-title" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("BusinessPurchaseApplyDetail.status")) + ": "
            ),
            _c("span", { staticClass: "red" }, [
              _vm._v(
                _vm._s(_vm.$t(_vm.PURCHASE_STATUS_LIST.bjGet(_vm.data.status)))
              ),
            ]),
          ]),
          _c("div", { staticClass: "flex-center" }, [
            _c("div", { staticClass: "text-center numBox" }, [
              _c("p", [
                _vm._v(_vm._s(_vm.$t("BusinessPurchaseApplyDetail.number"))),
              ]),
              _c("span", [_vm._v(_vm._s(_vm.data.planQty || 0))]),
            ]),
          ]),
        ]),
      ]),
      _c("BjDivider", [
        _vm._v(" " + _vm._s(_vm.$t("BusinessPurchaseApplyDetail.title"))),
      ]),
      _c("div", { staticClass: "bj-row mt20" }, [
        _c(
          "div",
          { staticClass: "bj-col" },
          [
            [
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(_vm._s(_vm.$t("BusinessPurchaseApplyDetail.code"))),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(_vm._s(_vm.data.code)),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(_vm._s(_vm.$t("table.createTimeText"))),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(_vm._s(_vm.data.creationDate)),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(_vm._s(_vm.$t("BusinessPurchaseComponentsPur.type"))),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(_vm.PURCHASE_TYPE.bjGet(_vm.data.purchaseType))
                    )
                  ),
                ]),
              ]),
            ],
            _c("div", { staticClass: "bj-form-item" }, [
              _c("div", { staticClass: "bj-form-item-label" }, [
                _vm._v(_vm._s(_vm.$t("BusinessPurchaseApplyDetail.remark"))),
              ]),
              _c("div", { staticClass: "bj-form-item-value" }, [
                _c("span", { staticStyle: { color: "red" } }, [
                  _vm._v(_vm._s(_vm.data.remarks)),
                ]),
              ]),
            ]),
          ],
          2
        ),
        _c("div", { staticClass: "bj-col" }, [
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(
                _vm._s(_vm.$t("BusinessPurchaseApplyDetail.warehouseCode"))
              ),
            ]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm._v(_vm._s(_vm.data.warehouseName)),
            ]),
          ]),
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(
                _vm._s(_vm.$t("BusinessPurchaseEntryComPage.header.supplier"))
              ),
            ]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm._v(_vm._s(_vm.data.supplierName)),
            ]),
          ]),
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(
                _vm._s(_vm.$t("BusinessPurchaseApplyDetail.reviewRemark1"))
              ),
            ]),
            _vm.data.remark
              ? _c("div", {
                  staticClass: "bj-form-item-value quill-editor",
                  domProps: { innerHTML: _vm._s(_vm.data.remark) },
                })
              : _vm._e(),
          ]),
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(
                _vm._s(_vm.$t("BusinessPurchaseApplyDetail.reviewRemark2"))
              ),
            ]),
            _vm.data.remark2
              ? _c("div", {
                  staticClass: "bj-form-item-value quill-editor",
                  domProps: { innerHTML: _vm._s(_vm.data.remark2) },
                })
              : _vm._e(),
          ]),
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(
                _vm._s(_vm.$t("BusinessPurchaseApplyDetail.reviewRemark3"))
              ),
            ]),
            _vm.data.remark3
              ? _c("div", {
                  staticClass: "bj-form-item-value quill-editor",
                  domProps: { innerHTML: _vm._s(_vm.data.remark3) },
                })
              : _vm._e(),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "bj-col" },
          [
            [
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("BusinessPurchaseApplyDetail.arrivalTime"))
                  ),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(_vm._s(_vm.data.expectedDate)),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("BusinessPurchaseComponentsPur.postingDate"))
                  ),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(_vm._s(_vm.data.postingDate)),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("BusinessPurchaseComponentsPur.documentDate"))
                  ),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(_vm._s(_vm.data.documentDate)),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("BusinessPurchaseComponentsPur.requiredDate"))
                  ),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(_vm._s(_vm.data.requiredDate)),
                ]),
              ]),
            ],
          ],
          2
        ),
      ]),
      _c("BjDivider", [
        _vm._v(
          " " +
            _vm._s(_vm.$t("BusinessPurchaseApplyDetail.productInformation")) +
            " "
        ),
      ]),
      _c(
        "div",
        { staticClass: "flex" },
        [
          _c("span"),
          _c("RightToolbar", { on: { showSetting: _vm.toolbarShow } }),
        ],
        1
      ),
      _vm.tableShow
        ? _c(
            "el-table",
            {
              attrs: {
                data: _vm.data.goodsList,
                border: "",
                script: "",
                "max-height": "600",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("table.countText"),
                  type: "index",
                  width: "65",
                  fixed: "left",
                  align: "center",
                },
              }),
              _vm.sortableSetting.skuCode
                ? _c("el-table-column", {
                    attrs: {
                      label: "SKU",
                      prop: "skuCode",
                      fixed: "left",
                      width: "133",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm.sortableSetting.planQty
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseApplyDetail.orderQty"),
                      prop: "planQty",
                      align: "center",
                      width: "130",
                    },
                  })
                : _vm._e(),
              _vm.sortableSetting.cnPurchasePrice
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseApply.cnPurchasePrice"),
                      prop: "cnPurchasePrice",
                      align: "center",
                      width: "120",
                    },
                  })
                : _vm._e(),
              _vm.sortableSetting.auPurchasePrice
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseDetailPage.table.Australian"
                      ),
                      prop: "auPurchasePrice",
                      align: "center",
                      width: "120",
                    },
                  })
                : _vm._e(),
              _vm.sortableSetting.price
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseDetailPage.table.Selling"),
                      prop: "price",
                      align: "center",
                      width: "120",
                    },
                  })
                : _vm._e(),
              _vm.sortableSetting.linkUrl
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseDetailPage.table.Link"),
                      prop: "linkUrl",
                      align: "center",
                      width: "140",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "https://" + row.linkUrl,
                                    target: "_blank",
                                  },
                                },
                                [_vm._v(_vm._s(row.linkUrl))]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      12636240
                    ),
                  })
                : _vm._e(),
              _vm.sortableSetting.linkMinPrice
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseDetailPage.table.Price"),
                      prop: "linkMinPrice",
                      align: "center",
                      width: "140",
                    },
                  })
                : _vm._e(),
              _vm.sortableSetting.expressPrice
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseDetailPage.table.Express"),
                      prop: "expressPrice",
                      align: "center",
                      width: "140",
                    },
                  })
                : _vm._e(),
              _vm.sortableSetting.consumptionTax
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseDetailPage.table.Consumption"
                      ),
                      prop: "consumptionTax",
                      align: "center",
                      width: "140",
                    },
                  })
                : _vm._e(),
              _vm.data.purchaseType !== "COMMON"
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseDetailPage.table.Platform"
                      ),
                      prop: "platformPrice",
                      align: "center",
                      width: "140",
                    },
                  })
                : _vm._e(),
              _vm.sortableSetting.taxCode
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseComponentsPur.table.TaxCode"
                      ),
                      prop: "taxCode",
                      align: "center",
                      width: "125",
                    },
                  })
                : _vm._e(),
              _vm.sortableSetting.requiredDate
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseComponentsPur.requiredDate"
                      ),
                      prop: "requiredDate",
                      align: "center",
                      width: "150",
                    },
                  })
                : _vm._e(),
              _vm.sortableSetting.dailySales
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseApply.table.dailySales"),
                      prop: "dailySales",
                      align: "center",
                      width: "100",
                    },
                  })
                : _vm._e(),
              _vm.sortableSetting.estimatedProfit
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseDetailPage.table.Estimated"
                      ),
                      prop: "estimatedProfit",
                      align: "center",
                      width: "125",
                    },
                  })
                : _vm._e(),
              _vm.sortableSetting.estimatedProfitRate
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseDetailPage.table.Expected"
                      ),
                      prop: "estimatedProfitRate",
                      align: "center",
                      width: "130",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                " " + _vm._s(row.estimatedProfitRate) + "% "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1376727228
                    ),
                  })
                : _vm._e(),
              _vm.sortableSetting.actualProfitRate
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseDetailPage.table.Actual"),
                      prop: "actualProfitRate",
                      align: "center",
                      width: "110",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("profitMarginFilter")(
                                      row.actualProfitRate
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3584385844
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  label: "refund & resend rate",
                  prop: "resendRefundRate",
                  align: "center",
                  width: "149",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("profitMarginFilter")(
                                  row.resendRefundRate
                                )
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  701093897
                ),
              }),
              _vm.sortableSetting.purchaseRiskLevel
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseDetailPage.table.risk"),
                      prop: "purchaseRiskLevel",
                      align: "center",
                      width: "117",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              row.purchaseRiskLevel
                                ? _c("div", [
                                    row.purchaseRiskLevel === "1"
                                      ? _c("span", {
                                          staticClass: "dot red_dto",
                                        })
                                      : row.purchaseRiskLevel === "2"
                                      ? _c("span", {
                                          staticClass: "dot yellow",
                                        })
                                      : _c("span", {
                                          staticClass: "dot green",
                                        }),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      246845808
                    ),
                  })
                : _vm._e(),
              _vm.sortableSetting.barCode
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseDetailPage.table.Barcode"),
                      prop: "barCode",
                      align: "center",
                      width: "120",
                    },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t(
                    "BusinessPurchaseDetailPage.table.cartonBoxBarcode"
                  ),
                  prop: "cartonBoxBarcode",
                  align: "center",
                  width: "160",
                },
              }),
              _vm.sortableSetting.brandName
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseDetailPage.table.brand"),
                      prop: "brandName",
                      align: "center",
                      width: "120",
                    },
                  })
                : _vm._e(),
              _vm.sortableSetting.categoryName
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseDetailPage.table.Product1"
                      ),
                      prop: "categoryName",
                      align: "center",
                      width: "145",
                    },
                  })
                : _vm._e(),
              _vm.sortableSetting.skuName
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseDetailPage.table.Description"
                      ),
                      prop: "skuName",
                      align: "center",
                      width: "150",
                    },
                  })
                : _vm._e(),
              _vm.sortableSetting.length
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseDetailPage.table.length"),
                      prop: "length",
                      align: "center",
                      width: "140",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [_vm._v(_vm._s(row.length) + " cm")]
                          },
                        },
                      ],
                      null,
                      false,
                      1405771782
                    ),
                  })
                : _vm._e(),
              _vm.sortableSetting.width
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseDetailPage.table.width"),
                      prop: "width",
                      align: "center",
                      width: "140",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [_vm._v(_vm._s(row.width) + " cm")]
                          },
                        },
                      ],
                      null,
                      false,
                      2532471484
                    ),
                  })
                : _vm._e(),
              _vm.sortableSetting.height
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseDetailPage.table.high"),
                      prop: "height",
                      align: "center",
                      width: "140",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [_vm._v(_vm._s(row.height) + " cm")]
                          },
                        },
                      ],
                      null,
                      false,
                      3273771973
                    ),
                  })
                : _vm._e(),
              _vm.sortableSetting.volume
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseDetailPage.table.Volume"),
                      prop: "volume",
                      align: "center",
                      width: "160",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    (row.width * row.height * row.length) /
                                      1000000
                                  ) +
                                  " m³ "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      610487067
                    ),
                  })
                : _vm._e(),
              _vm.sortableSetting.weight
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseDetailPage.table.Weight"),
                      prop: "weight",
                      align: "center",
                      width: "120",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [_vm._v(_vm._s(row.weight) + " kg")]
                          },
                        },
                      ],
                      null,
                      false,
                      288750872
                    ),
                  })
                : _vm._e(),
              _vm.sortableSetting.cartonLength
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseDetailPage.table.boxLength"
                      ),
                      prop: "cartonLength",
                      align: "center",
                      width: "110",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(" " + _vm._s(row.cartonLength) + " cm "),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2743676360
                    ),
                  })
                : _vm._e(),
              _vm.sortableSetting.cartonWidth
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseDetailPage.table.boxWidth"
                      ),
                      prop: "cartonWidth",
                      align: "center",
                      width: "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(" " + _vm._s(row.cartonWidth) + " cm "),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1891811634
                    ),
                  })
                : _vm._e(),
              _vm.sortableSetting.cartonHeight
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseDetailPage.table.boxheight"
                      ),
                      prop: "cartonHeight",
                      align: "center",
                      width: "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(" " + _vm._s(row.cartonHeight) + " cm "),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      161951307
                    ),
                  })
                : _vm._e(),
              _vm.sortableSetting.cartonVolume
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseDetailPage.table.boxVolume"
                      ),
                      prop: "cartonVolume",
                      align: "center",
                      width: "110",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    (row.cartonLength *
                                      row.cartonWidth *
                                      row.cartonHeight) /
                                      1000000
                                  ) +
                                  " m³ "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      524680542
                    ),
                  })
                : _vm._e(),
              _vm.sortableSetting.cartonWeight
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseDetailPage.table.boxWeight"
                      ),
                      prop: "cartonWeight",
                      align: "center",
                      width: "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(" " + _vm._s(row.cartonWeight) + " kg "),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3295479382
                    ),
                  })
                : _vm._e(),
              _vm.sortableSetting.qty
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseDetailPage.table.per"),
                      prop: "qty",
                      align: "center",
                      width: "110",
                    },
                  })
                : _vm._e(),
              _vm.sortableSetting.createdName
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseDetailPage.table.Buyer"),
                      prop: "createdName",
                      align: "center",
                      width: "140",
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "mt20 mb20 flex flex-spacebetween" }, [
        _c("span"),
        _c(
          "div",
          { staticClass: "font16", staticStyle: { color: "#3d3d3d" } },
          [
            _c("span", { staticClass: "mr20" }, [
              _vm._v(
                _vm._s(_vm.$t("BusinessPurchaseDetailPage.plantQtySum")) + "："
              ),
              _c("span", { staticClass: "font18" }, [
                _vm._v(_vm._s(_vm.planQtyTotal || 0)),
              ]),
            ]),
            _c("span", { staticClass: "mr20" }, [
              _vm._v(
                _vm._s(_vm.$t("BusinessPurchaseDetailPage.productVolume")) +
                  "："
              ),
              _c("span", { staticClass: "font18" }, [
                _vm._v(_vm._s(_vm.volumeTotal) + " m³"),
              ]),
            ]),
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("BusinessPurchaseDetailPage.cartonWeight")) + "："
              ),
              _c("span", { staticClass: "font18" }, [
                _vm._v(_vm._s(_vm.weightTotal) + " kg"),
              ]),
            ]),
          ]
        ),
      ]),
      _c("DialogAudit", {
        ref: "DialogAudit",
        attrs: { "audit-status": _vm.auditStatus },
        on: { confirm: _vm.onConfirm },
      }),
      _c("ElementTableSortable", {
        ref: "ElementTableSortable",
        attrs: {
          "page-type": _vm.sortableSettingPage,
          "sortable-setting": _vm.sortableSetting,
        },
        on: { settingTableTitle: _vm.settingTableTitle },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }